import { render, staticRenderFns } from "./index.vue?vue&type=template&id=082088a9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=082088a9&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=082088a9&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082088a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082088a9')) {
      api.createRecord('082088a9', component.options)
    } else {
      api.reload('082088a9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=082088a9&scoped=true", function () {
      api.rerender('082088a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/fileTemplateManage/index.vue"
export default component.exports